import { render, staticRenderFns } from "./AttachmentsContainer.vue?vue&type=template&id=2e6c33df&"
import script from "./AttachmentsContainer.vue?vue&type=script&lang=js&"
export * from "./AttachmentsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports